import { render, staticRenderFns } from "./gestionMora.vue?vue&type=template&id=55f2aef5"
import script from "./gestionMora.vue?vue&type=script&lang=js"
export * from "./gestionMora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports